// Module
var code = "<div data-bind=\"scrollFixer: {}\" class=\"iframe-container\"> <iframe src=\"https://spheeres.com\" class=\"iframe-element\" height=\"100%\"></iframe> </div>";
// Exports
export default code;